import { type QuotePackage, type PricingPlan } from "./helpers";
import { formatCurrency } from "helpers/currency";
import CollapsibleSection from "components/CollapsibleSection";
import PriceBreakdownContent from "./PriceBreakdownContent";
import WhatsIncludedContent from "./WhatsIncludedContent";
import CallButton from "components/CallButton";

/**
 * Preference Package Card (with yellow border)
 */
export default function PreferencePackageCard({
  pkg,
  isV2Market,
  plan,
}: {
  pkg: QuotePackage;
  isV2Market: boolean;
  plan?: PricingPlan;
}) {
  const displayName = pkg.external_plan_name || pkg.plan_name;
  const badgeText = isV2Market ? "QUOTE" : "BEST VALUE";
  const subtitle = plan?.external?.subtitle;
  const tagline = plan?.external?.tagline;

  return (
    <div className="relative rounded-md border-[3px] border-daisy p-6">
      {/* Badge */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2">
        <span className="rounded-full bg-daisy px-4 py-1 text-xs font-bold text-soil">
          {badgeText}
        </span>
      </div>

      <div className="mt-2 space-y-4">
        {/* Name and Price - horizontal */}
        <div className="flex items-center justify-between gap-2">
          <span className="font-serif text-3xl italic text-evergreen">
            {displayName}
          </span>
          <span className="text-3xl font-bold text-evergreen">
            {formatCurrency(pkg.total)}
          </span>
        </div>

        {/* Description */}
        {(subtitle || tagline) && (
          <p className="text-sm text-evergreen">
            {subtitle && <span className="font-bold">{subtitle}</span>}
            {tagline && ` ${tagline}`}
          </p>
        )}

        {/* Collapsible sections */}
        <div className="space-y-2">
          <CollapsibleSection title={`What's included in ${displayName}?`}>
            <WhatsIncludedContent
              highlights={plan?.external?.inclusion_highlights}
            />
          </CollapsibleSection>

          <CollapsibleSection title="View price breakdown">
            <PriceBreakdownContent pkg={pkg} />
          </CollapsibleSection>
        </div>

        {/* Call Button */}
        <CallButton variant="primary" />
      </div>
    </div>
  );
}
